import React from 'react';
import HeroSection from '@/sections/HeroSection';
import AboutSection from '@/sections/AboutSection';
import TradeFocusSection from '@/sections/TradeFocusSection';
import CraftHeritageSection from '@/sections/CraftHeritageSection';
import HowWeWorkSection from '@/sections/HowWeWorkSection';
import VisionSection from '@/sections/VisionSection';
import WhyFHISection from '@/sections/WhyFHISection';
import FAQSection from '@/sections/FAQSection';
import ContactSection from '@/sections/ContactSection';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <AboutSection />
      <HeroSection />
      <TradeFocusSection />
      <CraftHeritageSection />
      <HowWeWorkSection />
      <VisionSection />
      <WhyFHISection />
      <FAQSection />
      <ContactSection />
    </div>
  );
};

export default HomePage;
